import styles from "./TextBox.module.scss";
import cn from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export function TextBox(_ref) {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.textbox, className),
    children: children
  });
}